<template>
  <icon-menu>
    <template slot="icon">
      <v-avatar v-if="avatar" class="white--text avatar" :size="size" :style="style">
        <img :src="avatar" :alt="initials" />
      </v-avatar>
      <v-avatar v-else class="white--text avatar" :size="size" :style="style">{{
        initials
      }}</v-avatar>
    </template>
    <template slot="icon-menu-list">
      <div @click="myDetails" class="icon-menu__item">
        My details<apio-icon
          name="ui-edit"
          size="16"
          class="ml-4 icon-menu-item__icon"
        />
      </div>
      <div @click="logout" class="icon-menu__item">
        Logout<apio-icon
          name="ui-log-out"
          size="16"
          class="ml-4 icon-menu-item__icon"
        />
      </div>
    </template>
  </icon-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheHeaderDropdownAccnt",
  props: {
    dark: {
      type: Boolean,
    },
  },
  components: {
    IconMenu: () => import("@/components/Misc/IconMenu"),
  },
  computed: {
    ...mapState({
      username: (state) => state.auth.user,
      avatar: (state) => state.auth.avatar,
      invites: (state) => state.auth.invites,
    }),
    size() {
      return this.$vuetify.breakpoint.mobile ? 24 : 32;
    },
    style() {
      return this.$vuetify.breakpoint.mobile
        ? "'color: white; font-size: 10.5px; font-weight: 800;'"
        : "'color: white; font-size: 14px; font-weight: 800;'";
    },
    initials() {
      if (this.username == null) {
        return "";
      }
      let parts = this.username.split(/[ -]/);
      let initials = "";

      for (var i = 0; i < parts.length; i++) {
        initials += parts[i].charAt(0);
      }

      if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, "");
      }

      initials = initials.substr(0, 3).toUpperCase();

      return initials;
    },
  },
  methods: {
    myDetails() {
      this.$router.push('/my-details');
    },
    logout() {
      this.$store.dispatch("resetAppsState");
      this.$store.dispatch("resetAuthState");
      this.$store.dispatch("resetDashboardState");
      this.$store.dispatch("resetUsersState");
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-toolbar__content .v-btn.v-btn--icon.v-size--default {
  height: 32px !important;
  width: 32px !important;
}

.avatar {
  background-color: var(--apio-shade-3);
}

.v-avatar {
  font-size: 14px !important;
  width: 32px !important;
  height: 32px !important;
  margin-left: 4px;
}
</style>
